import { Typography, Box } from '@mui/material';
import React from 'react';
import { useManageDataCardOrderPreviewHeaderStyles } from 'components/TeamOverview/components/ManageDataCard/styles';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { ORDERS_SLIDE_LIST_URL } from 'constants/urls';
import { Link } from 'react-router-dom';

export const ManageDataCardOrderPreviewHeader = ({ handleBack, order }) => {
  const { classes } = useManageDataCardOrderPreviewHeaderStyles();

  if (!order) return null;

  return (
    <Box display="flex" alignItems="center" width="100%">
      <Box onClick={handleBack} className={classes.backContainer}>
        <ChevronLeftIcon fontSize={'large'} />
        <Typography className={classes.backLabel}>BACK</Typography>
      </Box>
      <Typography className={classes.cardTitle}>MANAGE DATA /</Typography>
      <Link
        className={classes.orderName}
        to={ORDERS_SLIDE_LIST_URL.replace(':orderUUID', order.uuid)}
      >
        <Typography className={classes.orderName}>{order.name}</Typography>
      </Link>
    </Box>
  );
};
